import { render, staticRenderFns } from "./categoryCard.vue?vue&type=template&id=21ff9656&scoped=true&"
import script from "./categoryCard.vue?vue&type=script&lang=js&"
export * from "./categoryCard.vue?vue&type=script&lang=js&"
import style0 from "./categoryCard.vue?vue&type=style&index=0&id=21ff9656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff9656",
  null
  
)

export default component.exports